import { render } from "./AgreementsModal.vue?vue&type=template&id=35b8b9ba&scoped=true&ts=true&lang=pug"
import script from "./AgreementsModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./AgreementsModal.vue?vue&type=script&lang=ts&setup=true"

import "./AgreementsModal.vue?vue&type=style&index=0&id=35b8b9ba&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35b8b9ba"]])

export default __exports__